/*
 * Artist Gallery built on VueJS
 */
import Vue from 'vue';

jQuery(document).ready(function($) {
    let ele         = document.getElementById('gallery-app');
    if(!ele) return;

    let page        = 1;
    let baseURL     = window.location.origin+'/';
    let feed        = "wp-json/wp/v2/gallery";
    let feedPerPage = "?per_page=12";
    let flkty       = null;

    let navArgs = {
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        cellAlign: 'left',
    }

    let argsMobile = {
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        cellAlign: 'center',
        adaptiveHeight: true,
        autoplay: false,
        lazyLoad: 2,
        initialIndex: 0,
        cellAlign: 'center',
        on: {
            ready: function(){
                let carousel = $(this.element);

                window.setTimeout(function(){
                    carousel.flickity('reloadCells');
                }, 300);
            },
            lazyLoad: function(){
                 placeArrows(flkty);
            },
            change: function(){
                $(this.element).flickity('reloadCells');
            }
        }
    }

    var app = new Vue({
        el: '#gallery-app',
        data: {
            isMobile: false,
            filterType: "all",
            results: 0,
            currentPage: 0,
            totalPages: 0,
            carouselsEnabled: false,
            galleryData: [],
            displayData: []
        },
        mounted: function () {
            const t = this;
            /* ------------------------------------------------
                Screen size check
            ------------------------------------------------ */
            t.$data.isMobile = (window.innerWidth < 600) ? true : false;
            window.onresize = function(){
                app.$data.isMobile = (window.innerWidth < 600) ? true : false;
            };


            /* ------------------------------------------------
                Request and store top level menu nav
            ------------------------------------------------ */
            t.fetchData();

            $('.project-filter a').on('click', function(e) {
                e.preventDefault();
                app.$data.filterType = $(this).attr('href').replace("#", '');

                $('.project-filter .active').removeClass('active');
                $(this).parent('li').addClass('active');

                app.filterData( app.$data.filterType );
            });

            window.addEventListener('resize', t.onResize);
        },
        updated: function(){
            const t = this;

            t.$nextTick(function (){
                if(t.$data.isMobile){
                    if(!t.$data.carousel){
                        t.scrollerInit();
                    }
                }

                if(typeof galleryTrigger != 'undefined'){
                    $('button[id="'+galleryTrigger+'"]').click();

                    var body = $("html, body");
                    body.stop().animate({scrollTop: $('button[id="'+galleryTrigger+'"]').parent().offset().top }, 500);
                }

                $('.trigger_gallery').click(function(e) {
                    e.preventDefault();

                    var galleryTrigger = $(this).attr('data-slug');

                    $('button[id="'+galleryTrigger+'"]').click();

                    var body = $("html, body");
                    body.stop().animate({scrollTop: $('button[id="'+galleryTrigger+'"]').parent().offset().top }, 500);
                });
            });
        },

        filters:{},

        methods:{
            filterData: function( filter ){
                console.log('Apply data filter for ' + filter);
                const keys = Object.keys( app.$data.galleryData );
                filter = filter.replaceAll("-", " ");

                let data = [];

                if(filter == "all"){
                    app.$data.displayData = app.$data.galleryData;
                }
                else{
                    keys.forEach((key, index) => {
                        if( app.$data.galleryData[key].artist_type == filter){
                            data.push(app.$data.galleryData[key])
                        }
                    });

                    app.$data.displayData = data;
               }

                app.repaintCarousel();
            },

            fetchData: function(){

                this.$data.currentPage = page;

                if(this.isMobile){
                    var dataFeed = baseURL+feed+'?per_page=100';
                }
                else{
                    var dataFeed = baseURL+feed+feedPerPage+'&page='+page;
                }

                 $.ajax({
                    url: dataFeed,
                    dataType: 'json',
                    success: function(dataObj, status, request) {

                        app.$data.results = parseInt (request.getResponseHeader('X-WP-Total'));
                        app.$data.totalPages = parseInt(  request.getResponseHeader('X-WP-TotalPages') );

                        for (var i = dataObj.length - 1; i >= 0; i--) {

                            var pageObj = {
                                id: dataObj[i].id,
                                slug: dataObj[i].slug,
                                url: dataObj[i].link,
                                title: dataObj[i].title.rendered,
                                description: dataObj[i].acf.project_description,
                                artist_name: dataObj[i].acf.artist_name,
                                artist_type: dataObj[i].acf.artist_type,
                                project: {
                                    artwork: {
                                        id: dataObj[i].acf.artwork.ID,
                                        alt: dataObj[i].acf.artwork.alt,
                                        original: dataObj[i].acf.artwork.url,
                                        mobile: (typeof dataObj[i].acf.artwork.sizes !== 'undefined') ? dataObj[i].acf.artwork.sizes['artwork-mobile'] : '',
                                        desktop: (typeof dataObj[i].acf.artwork.sizes !== 'undefined') ? dataObj[i].acf.artwork.sizes['artwork-desktop'] : '',
                                        alt: dataObj[i].acf.artwork.alt,
                                    }
                                }

                            };

                            app.$data.galleryData.push(pageObj);
                        }

                        $('.loader').remove();
                        app.$data.displayData = app.$data.galleryData;

                        app.filterData( app.$data.filterType );

                        // console.log('Success:', app.$data.results, app.$data.galleryData.length);

                        if(app.$data.galleryData.length < app.$data.results){
                            page = page + 1;
                            app.fetchData();
                        }

                    },
                    error: function(request, textStatus, errorThrown){
                        console.log(request, textStatus, errorThrown)
                    }
                })
            },

            loadMore: function(){
                page = page + 1;
                let lastProject = document.querySelectorAll('.project:last-child');
                lastProject[0].focus();

                app.fetchData();
            },

            onResize: function(){
                if(app.$data.isMobile){
                    if(!app.$data.carouselsEnabled){
                        app.initFilters();
                        app.initCarousel();
                    }
                }
                else{
                    if(app.$data.carouselsEnabled){
                        app.destroyFilters();
                        app.destroyCarousel();
                    }
                }
            },

            scrollerInit: function(){
                if(app.$data.isMobile){
                    app.initFilters();
                    app.initCarousel();
                }
            },

            initFilters: function(){
                const t         = this;
                let nav         = $('.project-filter ul');
                    nav         = nav.flickity(navArgs);

                t.$data.filters = nav;
            },

            initCarousel: function(){
                const t         = this;
                let scroller    = $(t.$el).children('.carousel--wrapper');

                if(scroller.children().length > 0){
                    scroller    = scroller.flickity(argsMobile);

                    t.$data.carousel = scroller;
                    t.$data.carouselsEnabled = true;
                }
            },

            destroyFilters: function(){
                $(app.$data.filters).flickity('destroy');
            },

            destroyCarousel: function(){
                $(app.$data.carousel).flickity('destroy');
                app.$data.carouselsEnabled = false;
            },

            repaintCarousel: function(){
                if(app.$data.isMobile){
                    app.destroyCarousel();

                    window.setTimeout(function(){
                        app.initCarousel();
                    }, 200);
                }
            }
        }
    });
});